import "./index.scss";
import { useNavigate } from "hooks/useCustomNavigation";
import { DSButton } from "components/UI/atoms";

export const EducationCard = ({ title, description, buttonText, linkTo }) => {
  const navigate = useNavigate();

  return (
    <div className="education-card">
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <DSButton
        variant="secondary"
        customClassName="education-card-button"
        onClick={() => navigate(linkTo)}
      >
        {buttonText}
      </DSButton>
    </div>
  );
};
